module.exports = __webpack_public_path__ + "img/Reticulum.d01e8b5c.png";